<template>
  <section
    class="max-w-4xl px-6 py-12 mx-auto text-neutral-800 dark:text-neutral-100"
  >
    <h1 class="mb-6 text-3xl font-bold">
      {{ $t("cookies.title") }}
    </h1>

    <article class="space-y-10">
      <section>
        <h2 class="mb-2 text-xl font-semibold">
          {{ $t("cookies.intro.title") }}
        </h2>
        <p>{{ $t("cookies.intro.text") }}</p>
      </section>

      <section>
        <h2 class="mb-2 text-xl font-semibold">
          {{ $t("cookies.whatAreCookies.title") }}
        </h2>
        <p>{{ $t("cookies.whatAreCookies.text") }}</p>
      </section>

      <section>
        <h2 class="mb-2 text-xl font-semibold">
          {{ $t("cookies.types.title") }}
        </h2>
        <ul class="ml-6 space-y-2 list-disc">
          <li>{{ $t("cookies.types.language") }}</li>
        </ul>
      </section>

      <section>
        <h2 class="mb-2 text-xl font-semibold">
          {{ $t("cookies.management.title") }}
        </h2>
        <p>{{ $t("cookies.management.text") }}</p>

        <ul class="mt-4 ml-6 space-y-1 list-disc">
          <li>
            <a
              href="https://support.google.com/chrome/answer/95647"
              target="_blank"
              rel="noopener"
              class="underline hover:text-primary-500"
              >Google Chrome</a
            >
          </li>
          <li>
            <a
              href="https://support.mozilla.org/pt-PT/kb/ativar-desativar-cookies"
              target="_blank"
              rel="noopener"
              class="underline hover:text-primary-500"
              >Mozilla Firefox</a
            >
          </li>
          <li>
            <a
              href="https://support.apple.com/pt-pt/guide/safari/sfri11471/mac"
              target="_blank"
              rel="noopener"
              class="underline hover:text-primary-500"
              >Safari</a
            >
          </li>
          <li>
            <a
              href="https://support.microsoft.com/pt-pt/help/17442/windows-internet-explorer-delete-manage-cookies"
              target="_blank"
              rel="noopener"
              class="underline hover:text-primary-500"
              >Microsoft Edge</a
            >
          </li>
        </ul>
      </section>
      <p class="text-sm italic text-neutral-500 dark:text-neutral-400">
        {{ $t("cookies.future") }}
      </p>
    </article>
  </section>
</template>
<script setup lang="ts">
const i18n = useI18n();
useSeoMeta({
  title: i18n.t("legalKeys.cookiePolicy"),
});
</script>
